import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Home } from 'lucide-react';
import { CartContext } from '../App';

const Navbar = () => {
  const { cart } = React.useContext(CartContext);
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <nav className="navbar" data-testid="main-navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" data-testid="nav-logo">
          <span className="logo-text">Annie's Butterfly Creations</span>
        </Link>
        
        <div className="navbar-menu">
          <Link to="/" className="nav-link nav-home-btn" data-testid="nav-home">
            <Home size={20} />
            <span>Home</span>
          </Link>
          <Link to="/shop" className="nav-link" data-testid="nav-shop">Shop</Link>
          <Link to="/admin/login" className="nav-link" data-testid="nav-admin">Admin</Link>
          <Link to="/cart" className="nav-link cart-link" data-testid="nav-cart">
            <ShoppingCart size={20} />
            {cartCount > 0 && (
              <span className="cart-badge" data-testid="cart-count">{cartCount}</span>
            )}
          </Link>
        </div>
      </div>

      <style jsx>{`
        .navbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          background: rgba(255, 254, 249, 0.95);
          backdrop-filter: blur(12px);
          border-bottom: 1px solid rgba(255, 155, 155, 0.2);
          z-index: 1000;
          padding: 1rem 2rem;
        }

        .navbar-container {
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .navbar-logo {
          text-decoration: none;
          color: #2D3748;
          transition: opacity 0.3s ease;
        }

        .navbar-logo:hover {
          opacity: 0.8;
        }

        .logo-text {
          font-family: 'Playfair Display', serif;
          font-size: 1.5rem;
          font-weight: 700;
          background: linear-gradient(135deg, #FF9B9B 0%, #B4A7FF 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .navbar-menu {
          display: flex;
          align-items: center;
          gap: 2rem;
        }

        .nav-link {
          text-decoration: none;
          color: #2D3748;
          font-weight: 500;
          font-size: 0.95rem;
          position: relative;
          transition: color 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .nav-link:hover {
          color: #FF9B9B;
        }

        .nav-home-btn {
          background: linear-gradient(135deg, #FF9B9B 0%, #B4A7FF 100%);
          color: white;
          padding: 0.6rem 1.2rem;
          border-radius: 50px;
          font-weight: 600;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          box-shadow: 0 2px 10px rgba(255, 155, 155, 0.2);
        }

        .nav-home-btn:hover {
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(255, 155, 155, 0.3);
        }

        .cart-link {
          position: relative;
          display: flex;
          align-items: center;
        }

        .cart-badge {
          position: absolute;
          top: -8px;
          right: -8px;
          background: #FF9B9B;
          color: white;
          border-radius: 50%;
          width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.7rem;
          font-weight: 600;
        }

        @media (max-width: 768px) {
          .navbar {
            padding: 1rem;
          }

          .logo-text {
            font-size: 1.2rem;
          }

          .navbar-menu {
            gap: 1rem;
          }

          .nav-link {
            font-size: 0.9rem;
          }

          .nav-home-btn {
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
          }

          .nav-home-btn span {
            display: none;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;